// extracted by mini-css-extract-plugin
export default {"table__container":"styles_table__container__Ax+hp","pagination__wrapper":"styles_pagination__wrapper__SDA1K","pagination__container":"styles_pagination__container__LmD2J"};